import { ReactNode, useState } from "react";
import { createUseStyles } from "react-jss";
import ArrowDownSLineIcon from "remixicon-react/ArrowDownSLineIcon";
import ArrowUpSLineIcon from "remixicon-react/ArrowUpSLineIcon";
import { Button, CircularProgress } from "@mui/material";

type Props = {
  className?: string;
  isToggleable?: boolean;
  leftHeader?: ReactNode;
  rightHeader?: ReactNode;
  customClassRightHeader?: string;
  customClassHeader?: string;
  children?: ReactNode;
  bodyClassName?: string;
  style?: any;
  isLoading?: boolean;
};

function InfonContainer({
  className = "",
  bodyClassName = "",
  isToggleable = false,
  leftHeader,
  rightHeader,
  customClassRightHeader,
  customClassHeader,
  children,
  style,
  isLoading = false,
}: Props) {
  const classes = useStyles();
  const [isHidden, setHidden] = useState(false);

  const toggle = () => {
    setHidden(!isHidden);
  };

  return (
    <div
      className={`${classes.infoContainer} ${
        className || classes.defaultWidth
      }`}
      style={style}
    >
      <div className={`${classes.headerContainer} ${customClassHeader}`}>
        <div className={classes.leftHeader}>{leftHeader}</div>
        <div className={`${classes.rightHeader} ${customClassRightHeader}`}>
          {rightHeader}
          {isToggleable && (
            <Button onClick={toggle} className={classes.arrowDown}>
              {isHidden ? <ArrowDownSLineIcon /> : <ArrowUpSLineIcon />}
            </Button>
          )}
        </div>
      </div>
      <div
        className={`${classes.bodyContainer} ${bodyClassName} ${
          isHidden ? classes.hidden : ""
        }`}
      >
        {isLoading ? <CircularProgress /> : children}
      </div>
    </div>
  );
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const useStyles = createUseStyles(() => ({
  defaultWidth: {
    width: "100%",
  },
  infoContainer: {
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    borderRadius: 5,
    boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2)",
    flexGrow: 1,
  },
  headerContainer: {
    display: "flex",
    justifyContent: "space-between",
    padding: 15,
    borderBottom: "#DFE1E6 solid 1px",
    "& button": {
      minWidth: "24px !important",
      margin: "0 5px",
      // padding: '0 !important',
    },
  },
  leftHeader: {
    display: "flex",
    alignItems: "center",
  },
  rightHeader: {
    display: "flex",
    alignItems: "center",
  },
  bodyContainer: {
    padding: 15,
    /* TODO CLARA : Ces props donnent un bug sur le tableau de produits
    maxHeight: "var(--fourtyVh)",
    overflowY: "auto",
     */
  },
  hidden: {
    display: "none",
  },
  infoHeader: {
    display: "flex",
    alignItems: "center",
  },
  arrowDown: {
    minWidth: "24px !important",
    margin: "0 5px !important",
    padding: "0 !important",
  },
}));

export default InfonContainer;
